
import { Advices } from './Advices';
import './DefaultLanding.css'

// @ts-ignore
const LoadingPopup = () => {

    const rootClasses = 'loading loading-active login-frame-container';

    return (
        <div className={rootClasses}>
         <div className='login-frame'>
             <div className="login-frame-text-loading">
                 <div className='progress3'></div>
                 <p>{Advices.get()}</p>
             </div>

         </div>

        </div>
    );
};

export default LoadingPopup;